<template>
    <div id="wrap" class="skpfull_wrap">
        <div class="rd_box history" :style="{ display: mode === 'list' ? 'block' : 'none' }">
            <div class="container history">
				<div class="title">
					<h1>{{$t('TITLE.EUR.REPAIR.INFO.HOSTORY')}}</h1>
				</div>
				<div class="content">
                    <div class="content_desc">
                        <p>{{$t('SUBTITLE.EUR.REPAIR.REQ.HISTORY')}}</p>
                        <button class="bt-type-l blue" @click="createReqRepair">{{$t('TITLE.REQUEST.REPAIR')}}</button>
                    </div>
                    <div class="grid_topBtn">
                        <a href="JavaScript:" class="txt_btn" @click="updateMyUserInfo">{{$t('TITLE.EUR.MY.USER.INFO')}}</a>
                        <a href="JavaScript:" class="txt_btn" @click="createVocQuest">{{$t('TITLE.EUR.VOC.QUESTION')}}</a>
                        <!--<a href="JavaScript:" class="txt_btn" @click="goLoginPage">{{$t('BUTTON.EUR.LOG.OUT')}}</a> -->
                    </div>
                    <!-- search -->
					<section class="search_box">
                        <div class="search_item">
                            <dl class="dl_select">
                                <dt>{{$t('FIELD.GLOBAL.ID')}}({{$t('FIELD.GLOBAL.EMAIL')}})</dt>
                                <dd data-input-type="text" class="full">{{email}}</dd>
                            </dl>
                            <dl class="dl_select">
                                <dt>{{$t('FIELD.GLOBAL.REQUEST.DATE')}}</dt>
                                <dd data-input-type="date">
                                    <fieldset class="ui_fieldset">
                                        <span class="date-wrap">
                                            <label>
                                                <input id="fromDate" type="text" class="date_input w80p bg_white" readonly :placeholder="$t('FIELD.KNOWLEDGE.SEARCH.FROMDATE')">
                                                <a href="javascript:" class="in_btn" id="icoFromDate"><i class="ico_date"></i><span class="sr_only">{{ $t('FIELD.GLOBAL.DATE') }}</span></a>
                                            </label>
                                            <div id="from-picker-container" style="margin-top: -1px;"></div>
                                        </span>
                                        <em class="txt_space"></em>
                                        <span class="date-wrap">
                                            <label>
                                                <input id="toDate" type="text" class="date_input w80p bg_white" readonly :placeholder="$t('FIELD.KNOWLEDGE.SEARCH.TODATE')">
                                                <a href="javascript:" class="in_btn" id="icoToDate"><i class="ico_date"></i><span class="sr_only">{{ $t('FIELD.GLOBAL.DATE') }}</span></a>
                                            </label>
                                            <div id="to-picker-container" style="margin-top: -1px;"></div>
                                        </span>
                                    </fieldset>
                                </dd>
                                <dt>{{$t('FIELD.APPROVAL.STATUS')}}</dt>
                                <dd data-input-type="select">
                                    <select class="slt_none w80p" v-model="reqStatus">
                                        <option value="">{{$t('FIELD.GLOBAL.ALL')}}</option>
                                        <option v-for="code in requestCodes" :key="code.CODE" :value="code.CODE">{{code.CODE_NM}}</option>
                                    </select>
                                </dd>
                            </dl>
                        </div>  
                        <div class="search_btn">
                            <button class="bt-type-sm black" @click="onSearch()">{{$t('BUTTON.GLOBAL.SEARCH')}}</button>
                        </div>
                    </section>
                    <!-- //search -->

                    <!-- grid -->
                    <section class="grid_box">
                        <!-- Grid -->
                        <div class="grid_wrap number-cell">
                            <!-- Count -->
                            <div class="grid_total">{{$t('TITLE.TOTAL.COUNT')}} : <em>{{totalCount}}</em></div>
                            <!-- Grid -->
                            <keep-alive>
                                <req-list-grid
                                    :gridId="gridId"
                                    :data="gridData"
                                    :columns="columns"
                                    :options="options"
                                    :pageOptions="pageOptions"
                                    :key="gridKey"
                                    :click="contentClick"
                                    :isTotalCount="false"
                                />
                            </keep-alive>
                        </div>
                    </section>
                    <!-- //grid -->
				</div>
			</div>
        </div>
        <my-info-view v-if="mode == 'view'"></my-info-view>
    </div>
    <!-- contents -->
</template>

<script>
import $                from 'jquery';
import qs               from 'query-string';
import Vue              from 'vue';
import api              from '@/service';
import axios            from 'axios';
import store            from '@/vuex/store';
import moment           from 'moment';
import SKPBreadcrumbs   from '~vb/main/SKPBreadcrumbs';
import { EventBus }     from '@/utils/EventBus';
import { SDLUtil }      from '@/utils';
import { mapGetters }   from 'vuex';
import ReqListGrid      from '~c/ToastGrid';
import DatePicker       from '~c/DatePicker';
import EditMyInfo       from './EditMyUserInfo';
import { i18n, loadLanguageAsync } from '@/i18n';

require('moment-jdateformatparser');
const fetchCode = (groupCd, langCd) =>
    axios.get(`${SDLUtil.API_URL}/noauth/eur/getCommonCodes.skp?groupCd=${groupCd}&langCd=${langCd}`);

// ToastGrid Tooltip renderer
class TooltipRenderer {
    constructor(props) {
        let rowKey = props.rowKey;
        let tipVal = props.grid.store.data.rawData[rowKey].APR_OPINION;
        console.log('tipVal ==> ', tipVal);
        let resVal = props.value;
        const el = document.createElement('span');
        el.innerText = resVal;
        el.title = tipVal;
        this.el = el;
    }
    getElement() {
        return this.el;
    }
};

export default {
    name: 'EurApproverNations',
    components: {
        'skp-breadcrumbs': SKPBreadcrumbs,
        'req-list-grid'  : ReqListGrid,
        'my-info-view'   : EditMyInfo
    },
    computed: {
        ...mapGetters({
            guid    : 'getGuid',    // GUID
            corpNo  : 'getCorpNo',
            loginId : 'getLoginId', // bpNo
            email   : 'getEmail',
            langCd  : 'getLangCd',
            countryCd  : 'getCountryCd',
//            countryNm  : 'getCountryNm',
            loginCountryCd  : 'getLoginCountryCd'
        })
    },
    data() {
        return {
            mode: 'list',
            pageTitle: '',
            totalCount: 0,
            rhqCd: 'EU',
            userEmail: this.email,
            reqStatus: '',
            strDate: '',
            endDate: '',
            params: {},
            requestCodes: [],
            gridId: 'reqHistGrid',
            gridKey: 0,
            gridData: [],
            columns: [],
            options: {
                scrollY: false,
                scrollX: false,
                rowHeight: 25,
            },
            pageOptions: {
                useClient: true,
                perPage: parseInt(localStorage.getItem('listRows') || 10),
            }
        };
    },
    methods: {
        async getCommonCodeList(groupCd) {
            const params = { groupCd: groupCd, langCd: this.langCd };
            const url = `${SDLUtil.API_URL}/noauth/eur/getCommonCodes.skp`;
            return axios
                .post(url, qs.stringify(params))
                .then(resp => {
                    this.gridData = resp.data.rows;
                    this.totalCount = this.gridData.length;
                    this.gridKey += 1;

                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    SDLUtil.showLoadingBar(false);
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                });
            const codeResp = await api.getCommonCodeList(v);
            return codeResp;
        },
        async getCodeComboList(categoryVal, categoryCode) {
            const codeResp = await api.getComboList(categoryVal, categoryCode, this.loginNo);
            return codeResp;
        },
        getColumns() {
            let columns = [
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.REQUEST.DATE'),
                    name: 'REQ_DT',
                    align: 'center',
                    width: 110,
                    sortable: true
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.MAJOR.PRODUCT.CATEGORY'),
                    name: 'PRD_CATEGORY_NM1',
                    align: 'center',
                    width: 240,
                    sortable: true
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.SUB.PRODUCT.CATEGORY'),
                    name: 'PRD_CATEGORY_NM2',
                    align: 'center',
                    width: 240,
                    sortable: true
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.MODEL.CODE'),
                    name: 'MODEL_CD',
                    align: 'center',
                    width: 140,
                    sortable: true
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.APPROVAL.STATUS'),
                    name: 'APR_STATUS_NM',
                    align: 'center',
                    width: 130,
                    sortable: true
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.COMMENT'), // New
                    name: 'APR_OPN_SHORT',
                    align: 'left',
//                    width: 100,
                    renderer: {type: TooltipRenderer },
                    sortable: true
                }
            ];
            this.columns = columns;
//            this.gridKey++;
        },
        onSearch() {
            SDLUtil.showLoadingBar(true);
            const mFormat = 'YYYY-MM-DD';
            let sParams = { loginId  : this.loginId
                          , corpNo   : this.corpNo
                          , locale   : this.langCd
                          , reqStatus: this.reqStatus 
                          , strDate  : this.rangePicker.getStartDate() ? moment(this.rangePicker.getStartDate()).format(mFormat) : ''
                          , endDate  : this.rangePicker.getEndDate() ? moment(this.rangePicker.getEndDate()).format(mFormat) : ''
            };
            const url = `${SDLUtil.API_URL}/noauth/eur/myRequestRepairs.skp`;
            axios.post(url, qs.stringify(sParams))
                .then(resp => {
                    console.log('resp==> ', resp);
                    this.gridData = resp.data.rows;
                    this.totalCount = this.gridData.length;
                    this.gridKey += 1;

                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    SDLUtil.showLoadingBar(false);
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                }
            );
        },
        // Update My Information - Button click
        updateMyUserInfo() {
            this.mode = 'view';
        },
        // Request Repair Info - Button click
        createReqRepair() {
            const pathUrl = `${SDLUtil.WEB_CONTEXT_PATH}/erp/requestRepairInfo`;
            this.$router.push({ path: pathUrl, query: {}});
        },
        // New Question - Button click
        createVocQuest() {
            const pathUrl = `${SDLUtil.WEB_CONTEXT_PATH}/erp/requestQuestion`;
            this.$router.push({ path: pathUrl, query: {}});
        },
        contentClick(data) {
            this.params = data;
        },
        goLoginPage() {
            const param = {countryCd: this.loginCountryCd, langCd: this.langCd};
            const pathUrl = `${SDLUtil.WEB_CONTEXT_PATH}/erp/login`;
            this.$router.push({ path: pathUrl, query: param});
        },
        goListBack(data) {
            this.mode = 'list';
//            this.onSearch();
        }
    },
    created() {
        loadLanguageAsync(this.langCd);
        EventBus.$on('goBackMyRepairs', this.goListBack);
    },
    beforeDestroy() {
        // [필수] EventBus 를 통해 등록된 이벤트는 컴포넌트 종료시 반드시 종료한다.
        EventBus.$off('goBackMyRepairs');
    },
    mounted() {
        $('body').addClass('reaair_wrap');
        this.$nextTick(() => {
            if (!SDLUtil.isEurLogin()) {
                SDLUtil.alert({
                    msg: 'MESSAGE.SESSION.HAS.EXPIRED',
                    onOkEvt: () => {
                        let pathUrl = `${SDLUtil.WEB_CONTEXT_PATH}/erp/login`;
                        this.$router.push({ path: pathUrl, query: {}});
                    }
                });
            } else {
                fetchCode('APPR_STATUS', this.langCd).then(res => {
                    this.requestCodes = res.data.rows;
                });

                setTimeout(() => {
                    this.getColumns();
                    this.onSearch();
                }, 200);

                let toDate = new Date();    
                let fromDate = toDate.setMonth(toDate.getMonth() - 1);
                this.rangePicker = DatePicker.createRangeWithOpener(
                    'from-picker-container', 'fromDate', 'icoFromDate',
                    'to-picker-container', 'toDate', 'icoToDate',
                    { type: 'date', locale: 'en', showToday: false },
                    (new moment()).add(-1, 'years').toDate(),
                    (new moment()).toDate()
                );

            }
//            console.log('loginCountryCd ==> ', this.loginCountryCd);
//            console.log('countryNm =======> ', this.countryNm);
        });

/*        this.getRhqCdList();
        SDLUtil.showLoadingBar(true);
        setTimeout(() => {
            this.onSearch();
        }, 400);
*/        
    },
};
</script>

<style>
.zindex9999 { z-index: 99999999; }
.top20 {top: -20px;}
.float-none {float: none;}
</style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/eur/user/MyRepairInfoHistory.vue